import { render, staticRenderFns } from "./AddChildLevel.vue?vue&type=template&id=b109daaa&scoped=true&"
import script from "./AddChildLevel.vue?vue&type=script&lang=js&"
export * from "./AddChildLevel.vue?vue&type=script&lang=js&"
import style0 from "./AddChildLevel.vue?vue&type=style&index=0&id=b109daaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b109daaa",
  null
  
)

export default component.exports